import request from './request'
import * as http from '@/libs/http'

/**
 * 店舗のオプション一覧を取得する
 *
 * @param {Number} shopid 店舗ID
 * @returns {Response} レスポンスデータ
 */
export function getShopOptions (shopid) {
  return request.get(`/shops/${shopid}/options`, {
    params: {
      fields: [
        'id',
        'categories',
        'type',
        'name',
        'image',
        'desc',
        'max',
        'cap',
        'unit',
        'chargeType',
        'maxDays',
        'unitCharge'
      ]
    },
    validateStatus: (status) => [
      http.OK,
      http.NoContent
    ].includes(status)
  })
}
